var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import * as CryptoJS from "crypto-js";
import { encrypt, getEnvironmentVariableOrEmpty } from "src/utils/methods";
import { captureSimpleAnalytics } from "../../../src/utils/analytics";
import styles from "../activate-segment/activate-segment.module.scss";
import SegmentDetails from "./segment-details";
import Modal from "react-modal";
import SuccessAnimation from "./success-animation";
import PendingAnimation from "./pending-animation";
import moment from "moment";
import { APP_SOURCE_SEGMENT_API, MERCHANT_KEY } from "src/utils/constant";
import { getClientInfoApi, getClientModificationStatus_V1, getJWTToken, } from "src/apis/dashboard";
import { getDataFromSession, SESSION_KEYS } from "src/utils/session-storage";
import RejectedAnimation from "./rejected-animation";
// import reqSuccesAnimation from "../../assets/svgs/reqSuccesAnimation.svg";
const { REACT_APP_URL_ACTIVATE_MODIFICATION } = process.env;
const ActivateSegment = () => {
    const captureclickData = () => {
        captureSimpleAnalytics("Activate Segment - FNO", "Activate now clicked");
    };
    const [showSegmentSuccessModal, setShowSegmentSuccessModal] = useState(false);
    const [showSegmentFailureModal, setShowSegmentFailureModal] = useState(false);
    const [showSegmentRejectedModal, setShowSegmentRejectedModal] = useState(false);
    const [segmentDetailsModal, setSegmentDetailsModal] = useState(false);
    const [segments, setSegments] = useState({
        cm_IsNSECurrency: { name: "Currency (NSE)", active: "" },
        cm_IsBSECurrency: { name: "Currency (BSE)", active: "" },
        cm_IsNSECash: { name: "Cash (NSE)", active: "" },
        cm_IsBSECash: { name: "Cash (BSE)", active: "" },
        cm_IsBSEFO: { name: "Futures and Options (BSE)", active: "" },
        cm_IsNSEFO: { name: "Futures and Options (NSE)", active: "" },
        cm_IsNSEMF: { name: "Mutual  Fund (NSE)", active: "" },
        cm_IsBSEMF: { name: "Mutual Fund (BSE)", active: "" },
        cm_IsMCXFO: { name: "Commodity (MCX)", active: "" },
    });
    const [dpAccountId, setDpAccountNo] = useState("");
    const toggleActiveSegmentModal = () => setSegmentDetailsModal((segmentDetailsModal) => !segmentDetailsModal);
    const toggleShowSegmentSuccessModal = () => {
        if (showSegmentSuccessModal)
            getClientModificationStatusFromApi();
        setShowSegmentSuccessModal((prev) => !prev);
    };
    const toggleShowSegmentPendingModal = () => {
        if (showSegmentFailureModal)
            getClientModificationStatusFromApi();
        setShowSegmentFailureModal((prev) => !prev);
    };
    const toggleShowSegmentRejectedModal = () => setShowSegmentRejectedModal((showSegmentRejectedModal) => !showSegmentRejectedModal);
    const checkSumRef = useRef("");
    const [holdingValue, setHoldingValue] = useState("");
    const [segmentStatus, setSegmentStatus] = useState("");
    const prepareSegmentsData = (data) => {
        const tempSegmentData = JSON.parse(JSON.stringify(segments));
        Object.keys(tempSegmentData).map((key) => {
            tempSegmentData[key].active = data[key];
        });
        setSegments(tempSegmentData);
    };
    const getClientInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getClientInfoApi();
        prepareSegmentsData(response.data.body.clientInfoResult.ClientInfo[0]);
        setDpAccountNo(response.data.body.clientInfoResult.CLDP[0].AccountNo);
    });
    useEffect(() => {
        // console.log("encrypt(getDataFromSession(SESSION_KEYS.CLIENT_CODE))",encrypt(getDataFromSession(SESSION_KEYS.CLIENT_CODE)))
        getClientInfo();
    }, []);
    const generateCheckSum = (merchantKey, parameters) => {
        let id = merchantKey + parameters;
        let hash = CryptoJS.MD5(id).toString(CryptoJS.enc.Hex).toUpperCase();
        return hash.substring(0, 16);
    };
    useEffect(() => {
        const todayDate = moment().format("DDMMYY");
        const clientCode = getDataFromSession(SESSION_KEYS.CLIENT_CODE);
        const parameter = clientCode + APP_SOURCE_SEGMENT_API + "192.168.10.100" + todayDate;
        checkSumRef.current = generateCheckSum(MERCHANT_KEY, parameter);
    }, []);
    const getClientModificationStatusFromApi = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const getJwtToken = yield getJWTToken(checkSumRef.current);
            if (!getJwtToken) {
                throw new Error("Failed to get JWT token");
            }
            const response = yield getClientModificationStatus_V1(checkSumRef.current, getJwtToken.data.body.Token);
            if (!response) {
                throw new Error("Failed to get client modification status");
            }
            let holdingValueFromApiKey = response.data.Result.body.Holdings;
            let clientKYCStatus = JSON.parse(JSON.parse(response.data.Result.body.KYCStatus).split(","));
            setSegmentStatus(clientKYCStatus.segmentStatus);
            let holdingVal = parseFloat(JSON.parse(holdingValueFromApiKey)[0].TotalHolding);
            setHoldingValue(holdingVal);
        }
        catch (e) {
            console.error(e);
        }
    });
    const handelRetry = () => {
        toggleShowSegmentRejectedModal();
        if (Number(holdingValue) >= 5000) {
            toggleActiveSegmentModal();
        }
        else {
            window.open(getEnvironmentVariableOrEmpty(REACT_APP_URL_ACTIVATE_MODIFICATION) +
                `/derivative/segment-details?ClientCode=${encrypt(getDataFromSession(SESSION_KEYS.CLIENT_CODE))}`);
        }
    };
    useEffect(() => {
        if (checkSumRef.current.length > 0) {
            getClientModificationStatusFromApi();
        }
    }, [checkSumRef.current]);
    const openPopupModal = () => {
        if (segmentStatus === "1") {
            toggleActiveSegmentModal();
        }
        else if (segmentStatus === "5") {
            toggleShowSegmentRejectedModal();
        }
        else {
            toggleShowSegmentPendingModal();
        }
    };
    const getActivateButton = () => {
        if (holdingValue === "" || segmentStatus === "") {
            return (_jsx("span", Object.assign({ className: `buyBtn large px-4 py-2 ${styles.disabled}` }, { children: "Activate Now" })));
        }
        if (Number(holdingValue) >= 5000) {
            return (_jsx("span", Object.assign({ className: "buyBtn large px-4 py-2", onClick: () => {
                    openPopupModal();
                } }, { children: "Activate Now" })));
        }
        else {
            if (segmentStatus === "1") {
                return (_jsx("span", Object.assign({ className: "buyBtn large px-4 py-2" }, { children: _jsx("a", Object.assign({ className: "whiteText", href: getEnvironmentVariableOrEmpty(REACT_APP_URL_ACTIVATE_MODIFICATION) +
                            `/derivative/segment-details?ClientCode=${encrypt(getDataFromSession(SESSION_KEYS.CLIENT_CODE))}`, target: "_blank", rel: "noreferrer", onClick: () => {
                            captureclickData();
                        } }, { children: "Activate Now" })) })));
            }
            else if (segmentStatus === "5") {
                return (_jsx("span", Object.assign({ className: "buyBtn large px-4 py-2", onClick: () => {
                        toggleShowSegmentRejectedModal();
                    } }, { children: "Activate Now" })));
            }
            else {
                return (_jsx("span", Object.assign({ className: "buyBtn large px-4 py-2", onClick: () => {
                        toggleShowSegmentPendingModal();
                    } }, { children: "Activate Now" }))
                // <span
                //   className="buyBtn large px-4 py-2"
                //   onClick={() => {
                //     toggleShowSegmentRejectedModal();
                //   }}
                // >
                //   Activate Rejected
                // </span>
                );
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.activateSegmentPanel}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.activateSegmentText}` }, { children: [_jsx("h6", { children: "Activate Derivative Segment" }), _jsx("p", Object.assign({ className: "medium regularWeight mt-1" }, { children: "Activate derivative segment to avoid order rejection" }))] })), getActivateButton()] })), _jsx(Modal, Object.assign({ isOpen: segmentDetailsModal, onRequestClose: toggleActiveSegmentModal, className: `${styles.myCommonModal} ${styles.segmentDetailsModal}`, overlayClassName: `${styles.myCommonOverlay}` }, { children: _jsx(SegmentDetails, { segments: segments, dpAccountId: dpAccountId, toggleActiveSegmentModal: toggleActiveSegmentModal, checkSum: checkSumRef.current, toggleShowSegmentSuccessModal: toggleShowSegmentSuccessModal, toggleShowSegmentPendingModal: toggleShowSegmentPendingModal }) })), _jsx(Modal, Object.assign({ isOpen: showSegmentSuccessModal, onRequestClose: toggleShowSegmentSuccessModal, className: `${styles.myCommonModal} ${styles.segmentStatusModal}`, overlayClassName: `${styles.myCommonOverlay}` }, { children: _jsxs("div", Object.assign({ className: `${styles.requestRaisedSec}` }, { children: [_jsx(SuccessAnimation, {}), _jsx("h6", Object.assign({ className: "mediumWeight" }, { children: "Request raised successfully !" })), _jsxs("p", Object.assign({ className: "medium mt-3" }, { children: ["We have received your Segment Modification request, ", _jsx("br", {}), " it will be updated in our system within next 48hrs."] })), _jsx("div", Object.assign({ className: `${styles.activateSegmentCtaWrapper} mt-5` }, { children: _jsx("button", Object.assign({ className: `${styles.activateSegmentCta} btnType1`, 
                                // type="submit"
                                onClick: () => toggleShowSegmentSuccessModal() }, { children: "Done" })) }))] })) })), _jsx(Modal, Object.assign({ isOpen: showSegmentFailureModal, onRequestClose: toggleShowSegmentPendingModal, className: `${styles.myCommonModal} ${styles.segmentStatusModal}`, overlayClassName: `${styles.myCommonOverlay}` }, { children: _jsxs("div", Object.assign({ className: `${styles.requestRaisedSec}` }, { children: [_jsx(PendingAnimation, {}), _jsx("h6", Object.assign({ className: "mediumWeight" }, { children: "Pending" })), _jsxs("p", Object.assign({ className: "medium mt-3 text-center" }, { children: ["Your request for segment activation", _jsx("br", {}), " has been successfully registered. It will ", _jsx("br", {}), " get activated in next 24-48 hrs."] })), _jsx("div", Object.assign({ className: `${styles.activateSegmentCtaWrapper} ${styles.btnPosBottom} mt-5` }, { children: _jsx("button", Object.assign({ className: `${styles.activateSegmentCta} btnType1`, 
                                // type="submit"
                                onClick: () => toggleShowSegmentPendingModal() }, { children: "Close" })) }))] })) })), _jsx(Modal, Object.assign({ isOpen: showSegmentRejectedModal, onRequestClose: toggleShowSegmentRejectedModal, className: `${styles.myCommonModal} ${styles.segmentStatusModal}`, overlayClassName: `${styles.myCommonOverlay}` }, { children: _jsxs("div", Object.assign({ className: `${styles.requestRaisedSec}` }, { children: [_jsx(RejectedAnimation, {}), _jsx("h6", Object.assign({ className: "mediumWeight" }, { children: "Rejected" })), _jsxs("p", Object.assign({ className: "medium mt-3 text-center" }, { children: ["Your request for segment activation", _jsx("br", {}), " has been rejected."] })), _jsx("div", Object.assign({ className: `${styles.activateSegmentCtaWrapper} ${styles.btnPosBottom} mt-5` }, { children: _jsx("button", Object.assign({ className: `${styles.activateSegmentCta} btnType1`, 
                                // type="submit"
                                onClick: () => handelRetry() }, { children: "Retry" })) }))] })) }))] }));
};
export default ActivateSegment;
